var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"round-img",on:{"click":function($event){return _vm.$emit('click')}}},[_c('BaseImg',{attrs:{"src":_vm.src}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }